import TableChart from "../../../../components/charts/tableChart";
import React from "react";
import {useLoggedInApi} from "../../../../api";
import {useQuery} from "react-query";

export default function TableContacted({filters}) {
    const api = useLoggedInApi()
    const query = useQuery(['properties', 'report', 'contacted_by_group', filters], () => {
        const resource = api.resource('properties/groups')
        return resource.getItem('contacted_by_group', {
            params: filters
        }).then(response => response.data)
    })

    return <TableChart
        isLoading={query.isLoading}
        rows={query.data?.map(row => ({
            label: row.property_groups__name, value: row.total
        }))}
        maxVisible={5}
        title={"CONTACTED"}
        headers={["PROPERTY GROUP", "COUNT"]}
        total={1000}/>
}